import defined from '~app/core/defined';

class LocationInfo {
  constructor(location, content) {
    this.location = location;

    if (defined(content)) {
      this.name = content.cellData.name;
      this.precipData = this._filterClimateData(content.cellData.precip);
      this.tempData = this._filterClimateData(content.cellData.heat, (h => h / 10.0));
      this.wildlifeInfo = {
        countAmphibians: content.cellData.count_amphibia,
        countMammals: content.cellData.count_mammalia,
        countReptiles: content.cellData.count_reptilia,
        species: content.cellData.wildlife,
      };

      this.biomeName = content.biomeData.biomeName;
      this.gradientStartColor = content.biomeData.gradientTopColor;
      this.gradientEndColor = content.biomeData.gradientBottomColor;

      if (defined(content.hotspotData)) {
        this.description = content.hotspotData.description;
        this.bannerImageDef = content.hotspotData.bannerImageDef;
        this.wideBannerImageDef = content.hotspotData.wideBannerImageDef;
        this.carouselImageDefs = content.hotspotData.carouselImageDefs;
      }
    }
    else {
      // If the content could not be loaded, throw up some defaults.
      this.gradientStartColor = [53, 53, 53];
      this.gradientEndColor = [31, 31, 31];
      this.wildlifeInfo = {
        countAmphibians: 0,
        countMammals: 0,
        countReptiles: 0,
        species: [],
      };
    }
  }

  get displayName() {
    // Default to return the reverse geocoding name baked into the database info.
    let name = this.name;

    if (defined(this.location.geocodedName)) {
      // We have a custom geocoded name from the location, so use that.
      name = this.location.geocodedName;
    }

    return name;
  }

  _filterClimateData(data, transform) {
    let filteredData = undefined;
    if (this._isNullClimateData(data) === false) {
      filteredData = data;
      if (defined(transform)) {
        filteredData = filteredData.map(transform);
      }
    }
    return filteredData;
  }

  _isNullClimateData(data) {
    let isAllNull = true;
    for (const datum of data) {
      if (defined(datum)) {
        isAllNull = false;
        break;
      }
    }
    return isAllNull;
  }
}

export default LocationInfo;



// WEBPACK FOOTER //
// ./src/core/locationInfo.js